/**
 * Shared "focus pill" chrome (Figma node 2402:84996): the corner-radius shape,
 * background, typography, and soft shadow common to both the static modal badge
 * (FocusIndicatorBadge) and the animated card indicator (AnimatedFocusPill), so
 * the two can't visually drift. Applied to each pill's filled element.
 *
 * Per-component concerns stay in each component: border widths/mechanism, sizing,
 * and the card indicator's hover animation.
 *
 * Kept as complete class literals so Tailwind's JIT emits them.
 */
export const FOCUS_PILL_CHROME =
  'tw-rounded-tl-2xl tw-rounded-tr-2xl tw-rounded-br-2xl tw-rounded-bl-[2px] ' +
  'tw-bg-indigo-50 tw-font-atkinson tw-font-bold tw-text-indigo-900 ' +
  'tw-drop-shadow-[0px_0px_7.5px_rgba(132,123,111,0.15)]';
